// https://www.typescriptlang.org/docs/handbook/unions-and-intersections.html?ref=hackernoon.com
import { z } from 'zod';
import type { TranslateFilterStrType } from './components/FilterByParameters/FilterTools';

// for test
export interface FilterItemMongoType {
    variable: string;
    condition: string;
    values: string | number | (string | number)[] | null;
}

export interface FilterHumanReadableType {
    key: string;
    description: TranslateFilterStrType;
    displayMethod: string;
    allAvailableEntries: { id: string; name: string }[];
    selectedIds: (number | string)[];
    active: boolean | null;
}

export const FilterMongoConditionSchema = z.enum([
    '$eq',
    '$ne',
    '$neq',
    '$gt',
    '$gte',
    '$lt',
    '$lte',
    '$in',
    '$nin',
    '$arr_in',
    '$arr_nin',
]);
export type FilterMongoCondition = z.infer<typeof FilterMongoConditionSchema>;

// export type FilterItemFieldName = 'ts' | 'obj_id' | 'tsdate' | 'x' | 'y' | 'x_snap' | 'y_snap' | 'alt' | 'speed' | 'direction' | 'group_id' | 'status' | 'status_last_changed_ts' | 'obj_name' | 'registration' | 'type' | 'color' | 'active';

// export type QueryType = Record<string, number | string | (number | string)[] | QueryGeometryType>;
export const QueryTypeSchema = z.record(
    z.union([
        z.string(),
        z.number(),
        z.array(z.union([z.string(), z.number()])),
        z.record(z.string(), z.any()),
    ])
);
export type QueryType = z.infer<typeof QueryTypeSchema>;

// export interface GeojsonFieldsType {
//     type?: string,
//     coordinates?: number[][][],
//     properties?: {
//         filter?: string, // radius | area
//     },
//     label?: string,
//     radius?: number,
// }
export const GeojsonFieldsSchema = z.object({
    type: z.string().optional(),
    coordinates: z.array(z.array(z.array(z.number()))).optional(),
    properties: z
        .object({
            filter: z.string().optional(),
        })
        .optional(),
    label: z.string().optional(),
    radius: z.number().optional(),
});
export type GeojsonFieldsType = z.infer<typeof GeojsonFieldsSchema>;

// export interface GeojsonType {
//     [key: string]: GeojsonFieldsType// $geometry | geometry
// }
// export const GeojsonTypeSchema = z.record(GeojsonFieldsSchema);
// export type GeojsonType = z.infer<typeof GeojsonTypeSchema>;

export const GeojsonTypeSchema = GeojsonFieldsSchema;
export type GeojsonType = z.infer<typeof GeojsonTypeSchema>;

// export type QueryGeometryType = {
//     [key: string]: GeojsonType // $geoWithin: { $geometry: { type: "Polygon", coordinates: [][][] } }
// }
// export const QueryGeometrySchema = z.record(z.record(GeojsonTypeSchema));
// export type QueryGeometryType = z.infer<typeof QueryGeometrySchema>;
export const QueryGeometrySchema = GeojsonTypeSchema;
export type QueryGeometryType = z.infer<typeof QueryGeometrySchema>;

// export type QueriesType =  Record<string, QueryType> | EmptyObject;
export const QueriesTypeSchema = z.union([z.record(QueryTypeSchema), z.object({})]); // .catch({});
export type QueriesType = z.infer<typeof QueriesTypeSchema>;

export interface EmptyObject {}

export const FilterColumnsSchema = z.object({
    order: z.array(z.string()),
    column: z.record(
        z.string(),
        z.object({
            label: z.string(),
            grp: z.array(z.string()),
        })
    ),
});
export interface FilterColumns extends z.infer<typeof FilterColumnsSchema> {}

export const FilterGroupsSchema = z.object({
    order: z.array(z.string()),
    group: z.record(
        z.string(),
        z.object({
            label: z.string(),
            fld: z.array(z.string()),
        })
    ),
});
export interface FilterGroups extends z.infer<typeof FilterGroupsSchema> {}
